/* Bequest — product-extras.js
   Comportamento dos blocos extras da página de produto e do "Featured product":
   modais (<dialog>), copiar cupom, produtos complementares (carregamento sob demanda),
   upsells adicionados junto com o produto, quantidade por pacote, campos personalizados
   obrigatórios, prazos de envio calculados no navegador e troca de variante do produto em destaque.
   Não altera theme.js: conversa com <product-form>/<variant-picker> só por eventos do DOM. */
(() => {
  if (window.__bqProductExtras) return;
  window.__bqProductExtras = true;

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const routes = (window.theme && window.theme.routes) || {};
  const cartAddUrl = (routes.cartAdd || '/cart/add') + '.js';

  /* ---------------- cliques: modais e cupom ---------------- */
  function copyText(txt) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt);
    return new Promise((ok) => {
      const ta = document.createElement('textarea');
      ta.value = txt;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (_) { /* sem suporte */ }
      ta.remove();
      ok();
    });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-pmodal-open]');
    if (opener) {
      const dlg = document.getElementById(opener.dataset.pmodalOpen);
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
        document.body.classList.add('no-scroll');
      }
      return;
    }
    const closer = e.target.closest('[data-pmodal-close]');
    if (closer) {
      const dlg = closer.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    // clique no fundo escuro: o alvo é o próprio <dialog> (o conteúdo fica dentro de .pmodal__box)
    if (e.target.matches && e.target.matches('dialog.pmodal')) {
      e.target.close();
      return;
    }
    const cp = e.target.closest('[data-copy-code]');
    if (cp) {
      const span = $('span', cp) || cp;
      const original = cp.dataset.label || span.textContent;
      cp.dataset.label = original;
      copyText(cp.dataset.copyCode).then(() => {
        span.textContent = cp.dataset.copied || original;
        cp.classList.add('is-copied');
        clearTimeout(cp._t);
        cp._t = setTimeout(() => { span.textContent = original; cp.classList.remove('is-copied'); }, 2000);
      });
    }
  });
  // ao fechar qualquer modal (Esc, botão ou fundo) libera a rolagem da página
  document.addEventListener('close', (e) => {
    if (e.target.matches && e.target.matches('dialog.pmodal')) document.body.classList.remove('no-scroll');
  }, true);

  /* ---------------- envio: submit do formulário principal ----------------
     Ouvimos o submit na fase de CAPTURA (no document), antes do <product-form> do theme.js.
     1) Campos personalizados obrigatórios vazios → cancela o envio e mostra o erro.
     2) Upsells marcados → adicionamos os upsells PRIMEIRO (POST /cart/add.js {items}) e depois
        reenviamos o mesmo formulário com form.requestSubmit(botão). Nesse segundo envio deixamos
        passar (marca data-extras-pass), e o <product-form> adiciona o produto principal normalmente,
        já renderizando o drawer com tudo (inclusive no modo "ir direto ao checkout" e no carrinho em página).
        Assim não há corrida entre duas chamadas ao carrinho e o theme.js fica intocado. */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const fid = form.getAttribute('id');
    if (!fid) return;
    if (form.dataset.extrasPass) { delete form.dataset.extrasPass; return; }

    // 1) campos obrigatórios
    let firstBad = null;
    $$('[data-prop-field][data-required]').forEach((wrap) => {
      const inp = $(`[form="${fid}"]`, wrap);
      if (!inp) return;
      const empty = inp.type === 'checkbox' ? !inp.checked : !String(inp.value || '').trim();
      const err = $('.pfield__err', wrap);
      if (err) err.hidden = !empty;
      wrap.classList.toggle('is-error', empty);
      if (empty && !firstBad) firstBad = inp;
    });
    if (firstBad) {
      e.preventDefault();
      e.stopImmediatePropagation();
      firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(() => firstBad.focus({ preventScroll: true }), 300);
      return;
    }

    // 2) upsells marcados para ESTE formulário
    const items = $$(`[data-upsells][data-form="${fid}"] [data-upsell-id]:checked`)
      .map((i) => ({ id: +i.dataset.upsellId, quantity: 1 }));
    if (!items.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const btn = e.submitter && e.submitter.form === form ? e.submitter : null;
    if (btn) btn.classList.add('is-loading');
    try {
      await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
    } catch (_) { /* upsell indisponível não impede a compra principal */ }
    if (btn) btn.classList.remove('is-loading');
    form.dataset.extrasPass = '1';
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn || undefined);
    else form.submit();
  }, true);

  /* ---------------- quantidade por pacote (quantity breaks) ---------------- */
  function initBundles(root) {
    $$('[data-bundle]:not([data-ready])', root).forEach((el) => {
      el.dataset.ready = '1';
      const fid = el.dataset.form;
      const own = $('[data-bundle-qty]', el);
      // se já existe um seletor de quantidade para o mesmo formulário, ele passa a ser o campo enviado
      const visible = $$(`input[name="quantity"][form="${fid}"]`).find((i) => i !== own);
      if (visible && own) own.remove();
      const target = visible || own;
      const radios = $$('[data-bundle-option]', el);
      const apply = () => {
        const r = radios.find((x) => x.checked) || radios[0];
        if (!r || !target) return;
        r.checked = true;
        target.value = r.value;
        if (visible) visible.dispatchEvent(new Event('change', { bubbles: true }));
      };
      el.addEventListener('change', (ev) => { if (ev.target.matches('[data-bundle-option]')) apply(); });
      if (visible) {
        // cliente mexeu no seletor visível: marca a opção que corresponde (ou nenhuma)
        visible.addEventListener('change', () => {
          radios.forEach((r) => { r.checked = r.value === String(visible.value); });
        });
      }
      apply();
    });
  }

  /* ---------------- complementares (Search & Discovery) ---------------- */
  function initComplementary(root) {
    $$('[data-complementary]:not([data-ready])', root).forEach((el) => {
      el.dataset.ready = '1';
      const load = () => fetch(el.dataset.complementary)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const res = html && $('[data-complementary-results]', parse(html));
          if (res && $('li', res)) {
            $('[data-complementary-list]', el).innerHTML = res.innerHTML;
            el.hidden = false;
          }
        })
        .catch(() => {});
      const watch = el.parentElement || el; // o próprio bloco está oculto (display:none não intersecta)
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((x) => x.isIntersecting)) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(watch);
      } else load();
    });
  }

  /* ---------------- prazos de envio (dias úteis) ---------------- */
  const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
  function addBusinessDays(date, n, skipWeekends) {
    const d = new Date(date.getTime());
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (!(skipWeekends && isWeekend(d))) left -= 1;
    }
    return d;
  }
  function shippingDates(el) {
    const skip = el.dataset.weekends === 'true';
    const now = new Date();
    let start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // pedido depois do horário de corte (ou no fim de semana) começa a ser preparado no próximo dia útil
    if (now.getHours() >= +el.dataset.cutoff || (skip && isWeekend(start))) start = addBusinessDays(start, 1, skip);
    const ship = addBusinessDays(start, +el.dataset.processing || 0, skip);
    const min = +el.dataset.min || 1;
    const max = Math.max(min, +el.dataset.max || min);
    return { now, ship, from: addBusinessDays(ship, min, skip), to: addBusinessDays(ship, max, skip) };
  }
  function formatter(kind) {
    const lang = document.documentElement.lang || undefined;
    const opts = kind === 'weekday' ? { weekday: 'short', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' };
    try { return new Intl.DateTimeFormat(lang, opts); } catch (_) { return new Intl.DateTimeFormat(undefined, opts); }
  }

  let countryPromise = null;
  function detectCountry() {
    if (countryPromise) return countryPromise;
    countryPromise = (async () => {
      try {
        const cached = sessionStorage.getItem('bq-country');
        if (cached) return JSON.parse(cached);
      } catch (_) { /* armazenamento bloqueado */ }
      const r = await fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } });
      const j = await r.json();
      const dv = j.detected_values || {};
      const c = dv.country || {};
      const out = { code: String(c.handle || c.code || '').toLowerCase(), name: c.name || dv.country_name || '' };
      try { sessionStorage.setItem('bq-country', JSON.stringify(out)); } catch (_) { /* ok */ }
      return out;
    })().catch(() => null);
    return countryPromise;
  }

  function initShipping(root) {
    $$('[data-ship-estimate]:not([data-ready])', root).forEach((el) => {
      el.dataset.ready = '1';
      const d = shippingDates(el);
      const f = formatter(el.dataset.format);
      const fmt = (x) => f.format(x);
      const shipTxt = $('[data-ship-text]', el);
      if (shipTxt) shipTxt.textContent = shipTxt.dataset.shipText.replace('[date]', fmt(d.ship));
      const arrTxt = $('[data-arrive-text]', el);
      if (arrTxt) {
        const a = fmt(d.from), b = fmt(d.to);
        arrTxt.textContent = arrTxt.dataset.arriveText.replace('[start]', a).replace('[end]', b);
      }
      const o = $('[data-date-order]', el);
      if (o) o.textContent = fmt(d.now);
      const s = $('[data-date-ship]', el);
      if (s) s.textContent = fmt(d.ship);
      const ar = $('[data-date-arrive]', el);
      if (ar) { const a = fmt(d.from), b = fmt(d.to); ar.textContent = a === b ? a : `${a} – ${b}`; }

      const dest = $('[data-ship-dest]', el);
      if (dest) {
        detectCountry().then((c) => {
          if (!c || !c.name) return;
          $('[data-dest-text]', dest).textContent = dest.dataset.shipDest.replace('[country]', c.name);
          const img = $('img', dest);
          if (img && /^[a-z]{2}$/.test(c.code)) {
            img.onerror = () => { img.hidden = true; };
            img.onload = () => { img.hidden = false; };
            img.alt = c.name;
            img.src = `https://flagcdn.com/h20/${c.code}.png`;
          }
          dest.hidden = false;
        });
      }
    });
  }

  /* ---------------- produto em destaque: preço/botão por variante ----------------
     Na home o Section Rendering do <variant-picker> não encontra a seção (ela não está no
     template de produto), então atualizamos preço e botão aqui com os dados JSON da seção. */
  document.addEventListener('change', (e) => {
    const fp = e.target.closest && e.target.closest('[data-fproduct]');
    const vp = fp && e.target.closest('variant-picker');
    if (vp) vp.dataset.updateUrl = 'false'; // não trocar a URL da página que exibe o destaque
  }, true);
  document.addEventListener('change', (e) => {
    const fp = e.target.closest && e.target.closest('[data-fproduct]');
    const vp = fp && e.target.closest('variant-picker');
    if (!vp || typeof vp.selected !== 'function') return;
    const json = $('[data-fp-variants]', fp);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const opts = vp.selected();
    const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
    if (!v) return; // o theme.js já marca como indisponível
    const sec = fp.dataset.fproduct;
    $$(`[data-swap="price-${sec}"]`).forEach((box) => {
      const sale = v.compare_cents > v.price_cents;
      box.innerHTML = `<div class="price price--lg${sale ? ' price--on-sale' : ''}" data-price>`
        + `<span class="${sale ? 'price__sale' : 'price__regular'}">${v.price}</span>`
        + (sale ? `<s class="price__compare">${v.compare}</s>` : '')
        + '</div>';
    });
    $$(`[data-section-buy="${sec}"]`).forEach((b) => {
      b.disabled = !v.available;
      if (v.available) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
      const label = $('span', b);
      if (label) label.textContent = v.available ? fp.dataset.addLabel : fp.dataset.soldLabel;
    });
  });

  /* ---------------- inicialização (página e editor do tema) ---------------- */
  function init(root = document) {
    initBundles(root);
    initComplementary(root);
    initShipping(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
